import "./footer.scss";
import { FaXTwitter } from "react-icons/fa6";
import { FaTelegramPlane } from "react-icons/fa";
import { SiGoogledocs } from "react-icons/si";
import { useTranslation } from '../../hooks/useTranslation';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col bg-[#010203] border-[1px] border-black/30 w-full transition-colors">
      <div className="flex flex-col mx-auto px-5 py-3 w-full max-w-[1440px]">
        <div className="flex sm:flex-row flex-col justify-between items-center w-full">
          <div className="flex flex-row justify-start items-end gap-1">
            <img src="/assets/images/logo.png" alt="pepe" className="rounded-full w-28" />
          </div>
          <div className="flex flex-row justify-end items-center gap-3 text-white">
            <a
              href="https://x.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-white/50 transition-colors"
              aria-label="Make Pepe on X"
            >
              <FaXTwitter size={26} />
            </a>
            <a
              href="https://t.me/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-white/50 transition-colors"
              aria-label="Make Pepe on Telegram"
            >
              <FaTelegramPlane size={26} />
            </a>
            <a
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-white/50 transition-colors"
              aria-label="Make Pepe Docs"
            >
              <SiGoogledocs size={24} />
            </a>
          </div>
        </div>
        <div className="flex flex-row justify-center mt-2 border-t-[1px] border-t-white/30 w-full">
          <p className="py-1 text-white text-sm">{t('footer.copyright')}</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
